import api from './client'

export interface WordFlashcard {
  id: number
  word: string
  meaning: string
  root?: string
  base64_image?: string
  memory_anchor?: string
  memory_hint?: string
  antonyms: string[]
  synonyms: string[]
  family_words: string[]
  context_sentences: string[]
  user_status?: string
}

export interface VocabTestWord {
  word_id: number
  word: string
  sentence: string
  choices: string[]
  correct_answer: string
}

export interface WordStatusItem {
  id: number
  word: string
  meaning: string
  status: string
}

export const vocabularyApi = {
  getDailyLearning: () => api.get<WordFlashcard[]>('/vocabulary/daily-learning'),
  getDailyReview: () => api.get<WordFlashcard[]>('/vocabulary/daily-review'),
  updateWordStatus: (wordId: number, status: string, mode: string) =>
    api.put('/vocabulary/word-status', { word_id: wordId, status, mode }),
  getProgress: () => api.get('/vocabulary/progress'),
  getWordsByStatus: (status: string) =>
    api.get<WordStatusItem[]>(`/vocabulary/words-by-status?status=${status}`),
  getFlashcard: (wordId: number) =>
    api.get<WordFlashcard>(`/vocabulary/flashcard/${wordId}`),
  getTestWords: () =>
    api.get<VocabTestWord[]>('/vocabulary/test-words'),
  submitTestResult: (wordId: number, isCorrect: boolean) =>
    api.put('/vocabulary/test-result', { word_id: wordId, is_correct: isCorrect }),
}
